export default __webpack_public_path__ + "static/media/bayern.df8b6678.png";